// extracted by mini-css-extract-plugin
module.exports = {"colorPromotion":"#fe823d","useFade-fadeIn":"CartPromotionsButton_useFade-fadeIn__5XZ9m","useFade-fadeOut":"CartPromotionsButton_useFade-fadeOut__OIgzM"};